<template>
  <label class="category">
    <div class="category-icon" v-html="category.icon"></div>
    <div class="category-name" :style="{ 'font-size': fontSize }">{{name}}</div>
    <input class="category-check" type="checkbox" v-model="selection" :value="category.key" :data-choice-category="category.key">
    <svg class="category-check" xmlns="http://www.w3.org/2000/svg" width="25" height="25">
      <path :class="selection.indexOf(category.key) > -1 ? 'category-checked' : 'category-unchecked'" fill-rule="evenodd" d="M12.5 25a12.5 12.5 0 1 0 0-25 12.5 12.5 0 0 0 0 25zm-2-6.6l9-8.9L18 8l-7.5 7.6-4-4.1L5 12.9l5.5 5.5z" clip-rule="evenodd"/>
    </svg>
  </label>
</template>

<script>
  export default {
    props: {
      category: null,
      value: null
    },
    computed: {
      fontSize () {
        const { length } = this.name
        const longest = longestWord(this.name).length
        return length < 12 && longest < 12 ? '17px' : 
          length < 20 && longest < 14 ? '15px' :
          length < 25 && longest < 16 ? '14px' :
          length < 30 ? '13px' : 
          length < 35 ? '12px' : '11px'
      },
      name () {
        return (this.$root.state.lang === 'fr' ? this.category.fr : this.category.nl) || ''
      },
      selection: {
        get () {
          return this.value || []
        },
        set (v) {
          this.$emit('input', v)
        }
      } 
    }
  }

  function longer (champ, contender) {
    return contender.length > champ.length ? contender : champ
  }

  function longestWord (str) {
    return str.split(' ').reduce(longer)
  }
</script>

<style>
  .category {
    display: block;
    appearance: none;
    position: relative;
    width: 135px;
    height: 135px;
    background: white;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.18), 0px 1px 2px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04);
    border-radius: 8px;
    padding: 1rem;
    user-select: none;
  }
  .category-name {
    position: absolute;
    bottom: 1rem;
    left: 1rem;
    right: 5px;
    font-style: normal;
    font-weight: normal;
    line-height: 1.3em;
    font-size: 17px;
    letter-spacing: -0.41px;
    color: #696E80;
    -ms-word-break: break-word;
    word-break: break-word;
    -webkit-hyphens: auto;
    -moz-hyphens: auto;
    hyphens: auto;
  }
  .category-check {
    position: absolute;
    top: .5rem;
    right: .5rem;
  }
  .category-checked {
    fill: #2DC76D;
  }
  .category-unchecked {
    fill: rgba(0, 0, 0, 0.2);
  }
  input.category-check {
    opacity: 0;
    visibility: hidden;
  }
</style>
